import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { ChipsModule } from 'primeng/chips';

@Component({
  selector: 'input-field-chip-formly-field',
  standalone: true,
  template: `
    <p class="mb-0">{{ props['addText'] }}</p>
    <p-chips
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      placeholder="Add text comma separated"
      separator=","
      styleClass="w-full"
    ></p-chips>
  `,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyPrimeNGModule,
    ChipsModule
  ]
})
export class InputFieldChipsField extends FieldType {}
